import { Reducer } from "redux";

import { ReauthDocumentReviewResponse } from "../models/Api/Document";
import { DocumentDetailActionDispatchTypes } from "../constants/Document";
import { ReauthDocumentDetailActionDispatchTypes } from "../models/DispatchTypes/Document";

export const initialPostState: ReauthDocumentReviewResponse = {
  loading: false,
  response: {
    referralDocument: {
      id: 0,
      reAuthId: 0,
      containsSupportedDoc: null,
      documentationDate: "",
      documentId: [],
      userCreated: null,
      type: 0,
      referralFaxParameterId: 0,
    },
    blobDocument: [],
  },
  error: null,
};

const ReauthDocumentReviewReducer: Reducer<
  ReauthDocumentReviewResponse,
  ReauthDocumentDetailActionDispatchTypes
> = (state = initialPostState, action) => {
  switch (action.type) {
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default ReauthDocumentReviewReducer;
